<template>
  <form-section
    :direction="direction"
    :error="error"
    :label="label"
    :label-visible="labelVisible"
    :name="name"
  >
    <div
      :class="inputClasses"
      class="switch-input"
    >
      <input
        ref="input"
        :id="name"
        :name="name"
        :disabled="isDisabled"
        class="switch-input__input"
        type="checkbox"
        @change="handleChange"
      >
      <label
        :for="name"
        class="switch-input__label"
      >
        <span class="switch-input__label__text--false">
          {{ falseLabel }}
        </span>
        <span class="switch-input__label__text--true">
          {{ trueLabel }}
        </span>
      </label>
      <div
        v-if="hasHint"
        class="switch-input__hint"
      >
        {{ hint }}
      </div>
    </div>
  </form-section>
</template>

<script>
import InputCommon from './InputCommon'

export default {
  name: 'SwitchInput',
  mixins: [InputCommon],
  props: {
    labelVisible: {
      type: Boolean,
      default: () => true
    },
    trueLabel: {
      type: String,
      default: () => 'On'
    },
    falseLabel: {
      type: String,
      default: () => 'Off'
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    inputClasses () {
      return {
        'switch-input--checked': this.value,
        'switch-input--disabled': this.isDisabled
      }
    }
  },
  watch: {
    value () {
      this.applyValue()
    }
  },
  methods: {
    handleChange (event) {
      this.$emit('input', event.target.checked)
    },
    applyValue () {
      if (this.$refs.input) {
        this.$refs.input.checked = !!this.value
      }
    }
  },
  mounted () {
    this.$nextTick(() => this.applyValue())
  }
}
</script>


<style lang="sass">
@import '~styles/imports'
@import '~styles/forms/mixins'

.switch-input
  +clearfix()
  display: flex
  justify-content: flex-start
  margin: rem-calc(15) rem-calc(0)
  user-select: none

.switch-input__input
  +visuallyhidden

.switch-input__label
  +font-size(12, 24)
  background: $color-white
  border-radius: rem-calc(24)
  border: 1px solid $color-grey-1
  cursor: pointer
  float: left
  height: rem-calc(28)
  padding: rem-calc(0 15 0 30)
  margin-top: 3px;
  position: relative
  transition: $global-transition

  &:before
    background: $color-grey-2
    border-radius: rem-calc(22)
    content: ''
    height: rem-calc(22)
    left: rem-calc(3)
    position: absolute
    top: rem-calc(2)
    transition: $global-transition
    width: rem-calc(22)

[class^="switch-input__label__text--"]
  position: relative
  top: rem-calc(1)

.switch-input__label__text--true
  display: none

.switch-input__label__text--false
  display: block

.switch-input--checked

  .switch-input__label
    background: $color-success
    border-color: $color-success
    color: $color-white
    padding: rem-calc(0 30 0 15)

    &:before
      left: calc(100% - 25px)
      background: $color-white

  .switch-input__label__text--true
    display: block

  .switch-input__label__text--false
    display: none

.switch-input__hint
  color: $color-grey-2
  font-size: rem-calc(15)
  font-weight: 500
  margin-left: rem-calc(15)

</style>



// WEBPACK FOOTER //
// src/components/forms/SwitchInput.vue